import { AppColors } from "@/styles/colors";
import { GridItem, Text } from "@chakra-ui/react";
import { DecisionActions } from "./DecisionActions";
import { DownloadButton } from "./DownloadButton";
import { DocDecision, SetDecisions } from "./types";
import { DOCUMENT_REQUIRED_MAP, DOCUMENT_TYPE_LABELS } from "@/constants/legal/societies/societies";
import { LegalOnboardingDocument } from "../../schema/handler-functions";

interface Props {
  doc: LegalOnboardingDocument;
  decision: DocDecision;
  showWaitingResend: boolean;
  disabledDownload: boolean;
  disabledDecision: boolean;
  hideDecisionActions: boolean;
  showMustStartReviewToast: () => void;
  setDecisions: SetDecisions;
  outerPaddingX: string;
  innerPaddingX: string;
  paddingY: string;
  columnGap: string;
}

export const DesktopDocRow = ({
  doc,
  decision,
  showWaitingResend,
  disabledDownload,
  disabledDecision,
  hideDecisionActions,
  showMustStartReviewToast,
  setDecisions,
  outerPaddingX,
  innerPaddingX,
  paddingY,
  columnGap,
}: Props) => {
  let decisionCell = (
    <DecisionActions
      docId={doc.id}
      decision={decision}
      disabled={disabledDecision}
      showMustStartReviewToast={showMustStartReviewToast}
      setDecisions={setDecisions}
    />
  );

  if (showWaitingResend) {
    decisionCell = (
      <Text
        fontWeight={600}
        fontSize={{ base: "12px", md: "13px", lg: "13px" }}
        backgroundColor={AppColors.GRAY_TEXT}
        color={AppColors.WHITE_SECONDARY}
        padding="4px 8px"
        borderRadius="6px"
      >
        Esperando reenvío...
      </Text>
    );
  } else if (hideDecisionActions) {
    decisionCell = (
      <Text
        fontWeight={600}
        fontSize={{ base: "12px", md: "13px", lg: "13px" }}
        color={AppColors.GRAY_TEXT}
        textAlign="center"
      >
        -
      </Text>
    );
  }

  return (
    <>
      <GridItem
        minW={0}
        paddingLeft={outerPaddingX}
        paddingRight={columnGap}
        paddingY={paddingY}
      >
        <Text
          fontWeight={600}
          fontSize={{ base: "12px", md: "13px", lg: "13px" }}
          color={AppColors.GRAY_TEXT}
          title={DOCUMENT_TYPE_LABELS[doc?.idTipoArchivo ?? 0]}
          css={{
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {DOCUMENT_TYPE_LABELS[doc?.idTipoArchivo ?? 0]?? "-"}
        </Text>
      </GridItem>

      <GridItem
        paddingLeft={innerPaddingX}
        paddingRight={columnGap}
        paddingY={paddingY}
      >
        <Text
          fontWeight={600}
          fontSize={{ base: "12px", md: "13px", lg: "13px" }}
          color={AppColors.GRAY_TEXT}
        >
          {DOCUMENT_REQUIRED_MAP[doc?.idTipoArchivo ?? 0] ? "Obligatorio" : "Opcional"}
        </Text>
      </GridItem>

      <GridItem
        paddingLeft={innerPaddingX}
        paddingRight={columnGap}
        paddingY={paddingY}
      >
        <DownloadButton
          disabled={disabledDownload}
          showMustStartReviewToast={showMustStartReviewToast}
          url={doc?.urlDescarga === '-' ? undefined : doc?.urlDescarga}   
          filename={doc?.nombre}
        />
      </GridItem>

      <GridItem
        justifySelf="center"
        paddingLeft={innerPaddingX}
        paddingRight={outerPaddingX}
        paddingY={paddingY}
        display={hideDecisionActions ? "none" : ""}
      >
        {decisionCell}
      </GridItem>
    </>
  );
};
